import React, { useMemo } from 'react';

// DEPENDENCIES
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';

// MAIN COMPONENT
const ListCell = ({
  children,
  value = children,
  placeholder
}) => {

  const valueMemo = useMemo(
    () => isArray(value) ? value.map((el, i) => isObject(el) ? <div key={i} className={el.className}>{el.value}</div> : <div>{el}</div> ) : value || placeholder,
    [value, placeholder]
  )

  // RENDER
  return <div className="w-100">{valueMemo}</div>;
};

// EXPORT
export default ListCell;
